module.exports = __webpack_public_path__ + "static/img/result.627048ca.png";